import * as SimstreamConstants from './constants';

export function clearStreamViolation() {
  return {
    type: SimstreamConstants.ActionKeys.CLEAR_STREAM_VIOLATION,
  };
}

export function createStreamViolation({
  errorTimeStamp,
  activeDeviceImageId,
  audioWarningTrack,
  dialogueDelay,
  dialogueHeader,
  dialoguePrompt,
  expiresSeconds,
}) {
  return {
    type: SimstreamConstants.ActionKeys.CREATE_STREAM_VIOLATION,
    data: {
      errorTimeStamp,
      activeDeviceImageId,
      audioWarningTrack,
      dialogueDelay,
      dialogueHeader,
      dialoguePrompt,
      expiresSeconds,
    },
  };
}

export function letMeListen(shouldStartStation) {
  return {
    type: SimstreamConstants.ActionKeys.LET_ME_LISTEN,
    data: { shouldStartStation },
  };
}

export function letThemListen() {
  return {
    type: SimstreamConstants.ActionKeys.LET_THEM_LISTEN,
  };
}

export function checkStreamViolation() {
  return {
    type: SimstreamConstants.ActionKeys.CHECK_STREAM_VIOLATION,
  };
}

export function updateStreamViolationIsStale() {
  return {
    type: SimstreamConstants.ActionKeys.UPDATE_STREAM_VIOLATION_IS_STALE,
  };
}

export default {
  clearStreamViolation,
  createStreamViolation,
  letMeListen,
  letThemListen,
  checkStreamViolation,
  updateStreamViolationIsStale,
};
